import Vue from 'vue'
import {RUN_PAN_VERIFY,RUN_VERIFY_LEAD_OTP,RUN_CREATE_LEAD,RUN_VERIFY_DOB,RUN_CONTACT_US,GET_INFO,GET_TOKEN,GET_USER,GET_LOADERS,SET_INFO,SET_STATE,SET_TOGGLE_LOADER,GET_MARGIN_CALCULATOR_LIST,
	SET_MARGIN_CALCULATOR_LIST,
	RUN_MARGIN_CALCULATOR} from '../types'
import * as RxFactory from './api/rx-factory'
import * as types from '@/types'

export const BASE_URL 					= 				 process.env.LOCAL_FACADE_SERVER_FULL_ADDRESS
export const EP_VERIFY_PAN				= 				'/api/verify/pan'
export const EP_CREATE_LEAD 			= 				'/api/create/lead'
export const EP_VERIFY_OTP_LEAD 		= 				'/api/verify/otp/lead'
export const EP_VERIFY_DOB 				= 				'/api/verify/kra'
export const EP_MARGIN_CALCULATOR		= 				'/api/website/marginCalculator'
export const EP_CONTACT_US				=				'/api/create/contactus'

export const actions = {
	
	[RUN_MARGIN_CALCULATOR]({commit, state, dispatch,getters}, req){
		try{				
		RxFactory.get(BASE_URL + EP_MARGIN_CALCULATOR, req)			  
			  .map(response => response.data)			  
			  .subscribe(data => {
				  if ('info' in data) {
					  if (data.info === 'OK') {
						commit(SET_MARGIN_CALCULATOR_LIST, data.data)  
					  }					  
				  }
			  },
			  e => {
				  _handleErrorResponse(e, commit)
			  }
		)
	  } catch (ex) {
		  _handleErrorResponse(ex, commit)
	  }
	},

	[RUN_PAN_VERIFY]({commit, state, dispatch,getters}, credentials){
		try{
			const parameter = credentials.parameter
			delete credentials.parameter
			const rout = credentials.rout
		  delete credentials.rout
		parameter.pageLoader = true

		RxFactory.post(BASE_URL + EP_VERIFY_PAN, credentials)
			  .map(response => response.data)
			  .subscribe(data => {
				  parameter.pageLoader = false
				  if ('info' in data) {
					  if (data.info === 'OK') {
						  parameter.pan_var_verify = true
						  parameter.res_msz= 'pan verified successfully'
						  parameter.mszType = 'success'
					  }
					  else{	
						 parameter.res_msz= data.msg
						 parameter.mszType = 'error'
					  }
				  }
			  },
			  e => {
				  _handleErrorResponse(e, commit)
			  }
		)
	  } catch (ex) {
		  _handleErrorResponse(ex, commit)
	  }
	},
	[RUN_CREATE_LEAD]({commit, state, dispatch,getters}, credentials){
		try{
			const parameter = credentials.parameter
			delete credentials.parameter
			const router = credentials.router
		  delete credentials.router
		  //parameter.pageLoader = true
			RxFactory.post(BASE_URL + EP_CREATE_LEAD, credentials)
			  .map(response => response.data)
			  .subscribe(data => {//parameter.pageLoader = false
				  if ('info' in data) {
					  if (data.info === 'OK') {
						  parameter.inserted_id = data.data.insertId
						  parameter.res_msz = "We have sent an OTP on email and mobile number that you have provided!";
						  parameter.mszType = 'success'
					  }
					  else{	
						  parameter.res_msz= data.msg	
						  parameter.mszType = 'error'
					}
				  }
			  },
			  e => {
				  _handleErrorResponse(e, commit)
			  }
		  )
	  } catch (ex) {
		  _handleErrorResponse(ex, commit)
	  }
	},
	[RUN_VERIFY_LEAD_OTP]({commit, state, dispatch,getters}, credentials){
		try{
			const parameter = credentials.parameter
			delete credentials.parameter
			const router = credentials.router
		  delete credentials.router
		 // parameter.pageLoader = true
			RxFactory.post(BASE_URL + EP_VERIFY_OTP_LEAD, credentials)
			  .map(response => response.data)
			  .subscribe(data => {//parameter.pageLoader = false
				  if ('info' in data) {
					  if (data.info === 'OK') {
						  parameter.STEP = 2
						   parameter.res_msz = 'Otp is verified successfully , please enter date of birth'
						   parameter.mszType = 'success'
					  }
					  else{	
					  parameter.res_msz= data.msg	
					  parameter.mszType = 'error'
					}
				  }
			  },
			  e => {
				  _handleErrorResponse(e, commit)
			  }
		  )
	  } catch (ex) {
		  _handleErrorResponse(ex, commit)
	  }
	},
	[RUN_VERIFY_DOB]({commit, state, dispatch,getters}, credentials){
		try{
			const parameter = credentials.parameter
			delete credentials.parameter
			const rout = credentials.rout
		  delete credentials.rout
		  //parameter.pageLoader = true
			RxFactory.post(BASE_URL + EP_VERIFY_DOB, credentials)
			  .map(response => response.data)
			  .subscribe(data => {//parameter.pageLoader = false
				  if ('info' in data) {
					  if (data.info === 'OK') {
						//   let path
						//   data.data.user.loggedIn = true
						//   commit(SET_STATE, data.data.user)
						//   localStorage.setItem('user', btoa(JSON.stringify(data.data.user)))
						  
						 parameter.res_msz = "Thankx for register with us , Your username and password sent your register email id !" 
						parameter.mszType = 'success'
						//   rout.replace({ name: "Users.UserRegisterStepZero",query:{msz:message } }) 
					  }
					  else{	parameter.res_msz= data.msg
					  	parameter.mszType = 'error'
						}
				  }
			  },
			  e => {
				  _handleErrorResponse(e, commit)
			  }
		  	)
	  } catch (ex) {
		  _handleErrorResponse(ex, commit)
	  }
	},
	[RUN_CONTACT_US]({commit, state, dispatch,getters}, credentials){
		try{
			const parameter = credentials.parameter
			delete credentials.parameter

		 	parameter.pageLoader = true

			RxFactory.post(BASE_URL + EP_CONTACT_US, credentials)
			  .map(response => response.data)
			  .subscribe(data => {
				  parameter.pageLoader = false
				  if ('info' in data) {
					  if (data.info === 'OK') {
						  //parameter.inserted_id = data.data.insertId
					  }
					  else{	
						  //parameter.flashError(data.msg, {timeout: msz_display_time});	
					}
				  }
			  },
			  e => {
				  _handleErrorResponse(e, commit)
			  }
		  	)
	  } catch (ex) {
		  _handleErrorResponse(ex, commit)
	  }
	},
}
//--------------------------------functions--------------------------------------
function _cleanUp (commit, msg, status, loaderId) {
  let loaderArr = (typeof loaderId !== 'undefined') ? [loaderId] : []
  commit(SET_TOGGLE_LOADER, loaderArr)
  commit(SET_INFO, msg)
}
function _handleErrorResponse (e, commit) {
    let response = {info: 'NOK', msg: 'Service not available'}
	if (typeof e.response === 'undefined') {
		try {
			const statusCheck = e.toString().toLowerCase()
			if (statusCheck.indexOf('network') > -1) {
			response = {info: 'NOK', msg: 'Network Error'}
			}
		} catch(e){}
	}else{
		if(e.response.status == '401'){
			let user = {
				active: 0,
				country: '',
				created: '',
				email: '',
				profile: {
					firstname: '',
					lastname: '',
					pid: '',
					cid: ''
				},
				roles: '',
				token: false,
				username: '',
				loggedIn: false
			}
			commit(SET_STATE, user)
			localStorage.setItem('user', '')
			window.location.href = "/";
		}
		response = e.response.data
	}
	_cleanUp(commit, response, response.status)
}
function _handleLogout (data, commit,options,getters) {
	const router = options.router
	// let user = {
		// active: 0,
		// country: '',
		// created: '',
		// email: '',
		// profile: {
			// firstname: '',
			// lastname: '',
			// pid: '',
			// cid: ''
		// },
		// roles: '',
		// token: false,
		// username: '',
		// loggedIn: false
	// }
	let user = {}
	localStorage.removeItem("user");
	localStorage.removeItem("margin_info");
	commit(SET_STATE, user)
	commit(SET_STATE_PERSIST_LOCAL)
	if ( 'msg' in data && 'info' in data) {
		_cleanUp(commit, data.msg, data.info)
	}
	if (options.forward === true) {
		
		router.replace('/')
	}
}





// WEBPACK FOOTER //
// ./src/store/actions.js